<template>
  <v-form
    @submit.prevent="submitSearchForm"
    class="form-search"
  >
    <v-text-field
      class="form-search__input"
      solo
      flat
      hide-details
      dense
      rounded
      autocomplete="off"
      :placeholder="$t(placeholder)"
      v-model.trim="searchInput"
      @change="onChangeInput"
    >
    </v-text-field>
    <v-btn
      class="form-search__btn"
      elevation="0"
      @click="submitSearchForm"
    >
      <svg-icon icon="search"></svg-icon>
    </v-btn>
  </v-form>
</template>
<script>
export default {
  name: 'SearchInput',
  props: {
    placeholder: { type: String, require: false, default: 'common.label.search' },
  },
  data () {
    return {
      searchInput: '',
      submitValue: '',
    };
  },
  methods: {
    submitSearchForm () {
      this.$emit('submit', this.searchInput);
      this.submitValue = this.searchInput;
    },
    onBlurInput () {
      if (this.submitValue !== this.searchInput) {
        this.submitSearchForm();
      }
    },
    onChangeInput (value) {
      console.log('onChangeInput', value);
      this.$emit('input', value);
    },
  },
};
</script>
